import * as S from './InfoTable.styled';

export interface ITableCell {
  label: string;
  value: string;
  key?: string;
  detailExposureYn?: string;
}

export interface IInfoTable {
  informs: ITableCell[];
  direction: 'row' | 'columns';
  type?: 'thin' | 'default';
  onClick?: (val: boolean) => void;
}

const InfoTable = ({ informs, direction = 'row', type = 'default', onClick }: IInfoTable) => {
  return (
    <>
      <S.Wrap>
        {informs?.map((item: any, idx: number) => {
          return (
            <S.TableRow direction={direction} key={item.key ?? idx}>
              <S.TableHead>{item.label}</S.TableHead>
              <S.TableBody type={type} underline={item.detailExposureYn === 'Y'}>
                <S.Content onClick={() => onClick && onClick(item.detailExposureYn === 'Y')} dangerouslySetInnerHTML={{
            __html: item.value.replace(/\n/g, '<br />'),
          }}></S.Content>
              </S.TableBody>
            </S.TableRow>
          );
        })}
      </S.Wrap>
    </>
  );
};

export default InfoTable;
